module.exports = __webpack_public_path__ + "img/Emoticon-Great.a34e5492.svg";